<template>
  <div class="all-order">
    <div class="all-order-content">
      <template v-if="list && list.length" >
        <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
          <template slot-scope="{ row, index }" slot="orderNum">{{row.orderNum}}</template>
          <template slot-scope="{ row, index }" slot="yonghu">{{row.yonghu}}</template>
          <template slot-scope="{ row, index }" slot="shouji">{{row.shouji}}</template>
          <template slot-scope="{ row, index }" slot="shangpin">
            <div style="position:relative">
              <div class="goods" v-for="(item,index) of row.shangpin" :key="index">
                <img :src="item">
              </div>
              <div class="goods-e" v-show="row.shangpin.length === 5">...</div>
            </div>
          </template>
          <template slot-scope="{ row, index }" slot="riqi">{{row.riqi}}</template>
          <template slot-scope="{ row, index }" slot="zhuangtai">{{row.zhuangtai}}</template>
          <template slot-scope="{ row, index }" slot="caozuo">
            <div class="operation">
              <span class="operation-1" @click="goDetail()">查看详情</span>
              <span style="margin:0 5px;">|</span>
              <span class="operation-2">确认发货</span>
            </div>
          </template>
        </Table>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "all-order",
  data() {
    return {
      list: [{
        orderNum: 1245255,
        yonghu: "第三方",
        shouji: 17701805135,
        shangpin: ["https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg"],
        riqi: "2019/10/21 14:05",
        zhuangtai: "待发货",
        caozuo: ""
        },{
          orderNum: 1245255,
          yonghu: "第三方",
          shouji: 17701805135,
          shangpin: ["https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg","https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg"],
          riqi: "2019/10/21 14:05",
          zhuangtai: "待发货",
          caozuo: ""
        },{
          orderNum: 1245255,
          yonghu: "第三方",
          shouji: 17701805135,
          shangpin: ["https://huizhanren.oss-cn-shanghai.aliyuncs.com/cloudExhibition/imgs/201910/c6da5fbaa77a43fbbc4952ccb30aab93.jpg"],
          riqi: "2019/10/21 14:05",
          zhuangtai: "待发货",
          caozuo: ""
      }],

      columns1: [
        {
          title: "订单号",
          key: "orderNum",
          slot: "orderNum",
          align: "center"
        },
        {
          title: "用户",
          slot: "yonghu",
          key: "yonghu",
          align: "center"
        },
        {
          title: "手机",
          slot: "shouji",
          key: "shouji",
          align: "center"
        },
        {
          title: "商品",
          slot: "shangpin",
          key: "shangpin",
          align: "center",
          width: "350px"
        },
        {
          title: "日期",
          slot: "riqi",
          key: "riqi",
          align: "center"
        },
        {
          title: "状态",
          slot: "zhuangtai",
          key: "zhuangtai",
          align: "center"
        },
        {
          title: "操作",
          slot: "caozuo",
          key: "caozuo",
          align: "center",
          width: "200px"
        }
      ], 
    }
  },
  methods: {
    goDetail() {
      this.$router.push('/exhibition/index/order/detail-order');
    }
  }
}
</script>

<style lang="scss" scoped>
.all-order {
  min-width: 1000px;
  padding: 30px;
  min-height: 500px;
  &-content {
    .goods {
      width: 18%;
      padding: 10% 0;
      display: inline-block;
      position: relative;
      margin: 0 3px;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        max-width: 100%;
        max-height: 100%;
        margin: auto;
      }
    }
    .goods-e {
      position: absolute;
      left: 100%;
      top: 30%;
      font-weight: bold;
    }
    .operation {
      color: #1890ff;
      cursor: pointer;
    }
  }
}
</style>